import { useContext } from 'react';
import { TimelineActionHandlerContext } from './TimelineActionHandlerContext';
import { jsx as _jsx } from "react/jsx-runtime";
/*
  Only use this with legacy React class components
  use `useContext` directly with functional components
 */
export const WithTimelineActionHandlerContext = Component => {
  const Wrapper = props => {
    const handleTimelineAction = useContext(TimelineActionHandlerContext);
    return /*#__PURE__*/_jsx(Component, Object.assign({
      handleTimelineAction: handleTimelineAction
    }, props));
  };
  Wrapper.displayName = 'WithTimelineActionHandlerContext';
  return Wrapper;
};